import { CropItem } from 'plugin-pdf-plot-area/webapp/api/utils/types'

export function getSpanCropItem(cropItem: CropItem): [string, string] {
    return [
        `ts ${cropItem.startSpan} to ts ${cropItem.endSpan}`,
        `ts ${cropItem.startSpanDepth} to ts ${cropItem.endSpanDepth}`
    ]
}
